var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M17.06 0l.077.08 9.617 9.617c.137.137.287.253.446.347v21.69A2.267 2.267 0 0124.933 34H2.267A2.267 2.267 0 010 31.733V2.267A2.267 2.267 0 012.267 0H17.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M7.367 0l7.366 10.2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M11.9 0l11.9 19.267H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F5F5F5",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#039F61",
    transform: "translate(15.867 23.8)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#06CF7F",
    transform: "translate(-2.267 14.733)",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 18.7,
    cy: 15.3,
    r: 2.833,
    fill: "#FFC404",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17 2.267l7.933 7.933H17z",
    mask: "url(#b)"
  }))));
};
export default SvgImage;